import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propStr, propBool, propArrayStr, propArrayOf, propOneOfType, } from '../../../../../helpers/custom-prop-types';
const SlideSearchPlanFunctions = (props) => {
    const { functions, list } = props;
    return (_jsx("ul", Object.assign({ className: 'slide_search_plan_functions' }, { children: functions.map((v, i) => (_jsx("li", Object.assign({ className: 'function_item' }, { children: _jsxs("dl", Object.assign({ className: 'item_inner' }, { children: [_jsx("dt", Object.assign({ className: 'item_title' }, { children: `・${v}` })), _jsx("dd", Object.assign({ className: 'item_value' }, { children: typeof list[i] === 'boolean' ? (_jsx("span", { className: clsx('item_icon', list[i] ? 'ok' : 'ng') })) : (list[i]) }))] })) }), v))) })));
};
SlideSearchPlanFunctions.propTypes = {
    functions: propArrayStr().isRequired,
    list: propArrayOf(propOneOfType([propBool(), propStr()])).isRequired,
};
export default SlideSearchPlanFunctions;
